// this an empty module given to webpack.node.js so that it doesn't waste time
// bundle a NPM module build, we use the plugins to do other build steps
// (such as copying assets into the lib dir)
export default '';
